import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import styles from './Calendar.st.css';
import React from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import classNames from 'classnames';
import { addMonths, subMonths, startOfMonth, isSameDay } from 'date-fns';
import { CalendarView } from './utils';
import localeUtilsFactory from '../LocaleUtils';
import DatePickerHead from './DatePickerHead';
import { legacyParse } from '@date-fns/upgrade/v2';

var Calendar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Calendar, _React$PureComponent);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setMonth", function (month) {
      _this.setState({
        month: month
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDayClick", function (value) {
      var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      _this._preventActionEventDefault(event);

      var propsValue = _this.props.value || {};
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          shouldCloseOnSelect = _this$props.shouldCloseOnSelect;

      if (_this.props.selectionMode === 'range') {
        if (!propsValue.from && !propsValue.to || propsValue.from && propsValue.to) {
          onChange({
            from: value
          }, modifiers);
        } else {
          var anchor = propsValue.from || propsValue.to;
          var newVal = anchor < value ? {
            from: anchor,
            to: value
          } : {
            from: value,
            to: anchor
          };
          onChange(newVal, modifiers);
          shouldCloseOnSelect && _this.props.onClose(event);
        }
      } else {
        onChange(value, modifiers);
        shouldCloseOnSelect && _this.props.onClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_preventActionEventDefault", function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      // We should not prevent "TAB"/"ESC" key
      if (event && (!event.keyCode || !_this.keyHandlers[event.keyCode])) {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_createCaptionElement", function (month) {
      var _this$props2 = _this.props,
          locale = _this$props2.locale,
          showMonthDropdown = _this$props2.showMonthDropdown,
          showYearDropdown = _this$props2.showYearDropdown;
      var localeUtils = localeUtilsFactory(locale);
      return /*#__PURE__*/React.createElement(DatePickerHead, {
        date: month,
        showYearDropdown: showYearDropdown,
        showMonthDropdown: showMonthDropdown,
        localeUtils: localeUtils,
        onChange: _this._setMonth,
        onLeftArrowClick: function onLeftArrowClick() {
          return _this._setMonth(startOfMonth(addMonths(month, -1)));
        },
        onRightArrowClick: function onRightArrowClick() {
          return _this._setMonth(startOfMonth(addMonths(month, 1)));
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_createDayPickerProps", function () {
      var _this$props3 = _this.props,
          locale = _this$props3.locale,
          filterDate = _this$props3.filterDate,
          excludePastDates = _this$props3.excludePastDates,
          numOfMonths = _this$props3.numOfMonths,
          firstDayOfWeek = _this$props3.firstDayOfWeek;
      var value = Calendar.parseValue(_this.props.value);
      var month = _this.state.month;
      var localeUtils = localeUtilsFactory(locale);

      var _ref = value || {},
          from = _ref.from,
          to = _ref.to;

      var singleDay = !from && !to && value;
      var firstOfMonth = [new Date(month.getFullYear(), month.getMonth(), 1), new Date(month.getFullYear(), month.getMonth() + 1, 1)];
      var lastOfMonth = [new Date(month.getFullYear(), month.getMonth() + 1, 0), new Date(month.getFullYear(), month.getMonth() + 2, 0)];

      var captionElement = _this._createCaptionElement(month);

      var selectedDays = _this._getSelectedDays(value);

      return {
        disabledDays: excludePastDates ? {
          before: new Date()
        } : function (date) {
          return !filterDate(new Date(date));
        },
        initialMonth: month,
        initialYear: month,
        selectedDays: selectedDays,
        month: month,
        year: month,
        firstDayOfWeek: firstDayOfWeek,
        locale: typeof locale === 'string' ? locale : '',
        fixedWeeks: true,
        onKeyDown: _this._handleKeyDown,
        onDayClick: _this._handleDayClick,
        localeUtils: localeUtils,
        navbarElement: function navbarElement() {
          return null;
        },
        captionElement: captionElement,
        onCaptionClick: _this._preventActionEventDefault,
        onDayKeyDown: _this._handleDayKeyDown,
        numberOfMonths: numOfMonths,
        className: numOfMonths > 1 ? styles.TwoMonths : '',
        modifiers: {
          start: from,
          end: to,
          firstOfMonth: firstOfMonth,
          lastOfMonth: lastOfMonth,
          singleDay: singleDay
        },
        renderDay: Calendar.renderDay
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (event) {
      var keyHandler = _this.keyHandlers[event.keyCode];
      keyHandler && keyHandler(event);
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandlers", {
      // escape
      27: _this.props.onClose,
      // tab
      9: _this.props.onClose
    });

    _defineProperty(_assertThisInitialized(_this), "_focusSelectedDay", function () {
      if (_this.dayPickerRef) {
        var selectedDay = _this.dayPickerRef.dayPicker.querySelector('.DayPicker-Day--selected');

        if (selectedDay) {
          selectedDay.classList.add('DayPicker-Day--unfocused');
          selectedDay.focus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDayKeyDown", function (_value, _modifiers) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      _this._preventActionEventDefault(event);

      var unfocusedDay = _this.dayPickerRef.dayPicker.querySelector('.DayPicker-Day--unfocused');

      if (unfocusedDay) {
        unfocusedDay.classList.remove('DayPicker-Day--unfocused');
      }
    });

    var initialMonth = Calendar.getUpdatedMonth(props.value, props.numOfMonths);
    _this.state = {
      month: initialMonth || new Date()
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        var month = Calendar.getUpdatedMonth(nextProps.value, nextProps.numOfMonths, this.state.month);

        if (month) {
          this.setState({
            month: month
          });
        }
      }
    }
  }, {
    key: "_getSelectedDays",
    value: function _getSelectedDays(value) {
      var _ref2 = value || {},
          from = _ref2.from,
          to = _ref2.to;

      if (from && to) {
        return {
          from: from,
          to: to
        };
      } else if (from) {
        return {
          after: prevDay(from)
        };
      } else if (to) {
        return {
          before: nextDay(to)
        };
      } else {
        // Single day OR empty value
        return value;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this._focusSelectedDay();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.autoFocus && this.props.autoFocus) {
        this._focusSelectedDay();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          dataHook = _this$props4.dataHook,
          className = _this$props4.className;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: classNames(styles.calendar, className),
        onClick: this._preventActionEventDefault
      }, /*#__PURE__*/React.createElement(DayPicker, _extends({
        ref: function ref(_ref3) {
          return _this2.dayPickerRef = _ref3;
        }
      }, this._createDayPickerProps())));
    }
  }], [{
    key: "areValuesEqual",
    value: function areValuesEqual() {
      var value1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var value2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!Boolean(value1) && !Boolean(value2)) {
        return true;
      }

      if (Calendar.isRangeValue(value1) && Calendar.isRangeValue(value2)) {
        return isSameDay(value1.from, value2.from) && isSameDay(value1.to, value2.to);
      }

      return isSameDay(value1, value2);
    }
  }, {
    key: "renderDay",
    value: function renderDay(day, modifiers) {
      var relevantModifiers = ['start', 'end', 'selected'];

      for (var _i = 0, _relevantModifiers = relevantModifiers; _i < _relevantModifiers.length; _i++) {
        var modifier = _relevantModifiers[_i];

        if (modifier in modifiers) {
          return /*#__PURE__*/React.createElement("div", {
            className: styles.dayCircle,
            "data-date": "".concat(day.getFullYear(), "-").concat(day.getMonth(), "-").concat(day.getDate())
          }, day.getDate());
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        "data-date": "".concat(day.getFullYear(), "-").concat(day.getMonth(), "-").concat(day.getDate())
      }, day.getDate());
    }
  }, {
    key: "isSingleDay",
    value: function isSingleDay(value) {
      return value instanceof Date;
    }
  }, {
    key: "isRangeValue",
    value: function isRangeValue(value) {
      return Boolean(value.from || value.to);
    }
  }]);

  return Calendar;
}(React.PureComponent);

_defineProperty(Calendar, "displayName", 'Calendar');

_defineProperty(Calendar, "defaultProps", {
  locale: 'en',
  className: '',
  filterDate: function filterDate() {
    return true;
  },
  shouldCloseOnSelect: true,
  onClose: function onClose() {},
  autoFocus: true,
  excludePastDates: false,
  selectionMode: 'day',
  showMonthDropdown: false,
  showYearDropdown: false,
  numOfMonths: 1,
  firstDayOfWeek: 1
});

_defineProperty(Calendar, "optionalParse", function (dateOrString) {
  return typeof dateOrString === 'string' ? legacyParse(dateOrString) : dateOrString;
});

_defineProperty(Calendar, "parseValue", function (value) {
  if (!value) {
    return new Date();
  }

  if (typeof value === 'string') {
    return legacyParse(value);
  } else if (value instanceof Date) {
    return value;
  } else {
    return {
      from: Calendar.optionalParse(value.from),
      to: Calendar.optionalParse(value.to)
    };
  }
});

_defineProperty(Calendar, "getUpdatedMonth", function (nextPropsValue, numOfMonths, currentMonthDate) {
  var nextValue = Calendar.parseValue(nextPropsValue);

  if (!currentMonthDate) {
    return Calendar.isSingleDay(nextValue) ? nextValue : nextValue.from || nextValue.to;
  }

  var view = new CalendarView(currentMonthDate, numOfMonths);

  if (Calendar.isSingleDay(nextValue)) {
    if (!view.isContained(nextValue)) {
      return nextValue;
    }
  } else {
    var from = nextValue.from,
        to = nextValue.to;

    if (from && view.isAfterView(from)) {
      //         F--- =>  F---
      //   VVVVV      =>  VVVVV
      return from;
    } else if (to && view.isBeforeView(to)) {
      if (view.isRangeFits(from, to)) {
        //   F-T        =>  F-T
        //       VVVVV  =>  VVVVV
        return from;
      } else {
        //   F-----T        =>  F-----T
        //          VVVVV    =>    VVVVV
        return subMonths(to, numOfMonths - 1);
      }
    } else if (from && view.isBeforeView(from) && to && view.isAfterView(to)) {
      //   F-------T  =>    F-------T
      //     VVVVV    =>    VVVVV
      return from; // choose the 'from' anchor arbitrarly
    }
  }
  /*
   * We only changed the month if the day (or range.edges) are outside the view.
   * This is to avoid changing the month right after a user clicks on the calendar.
   */


  return null;
});

export { Calendar as default };
Calendar.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Auto focus on selected day when component mounts or updates */
  autoFocus: PropTypes.bool,

  /** Display multiple months, currently allowing only 1 or 2 */
  numOfMonths: PropTypes.oneOf([1, 2]),

  /** First day of the week, allowing only from 0 to 6 (Sunday to Saturday) */
  firstDayOfWeek: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),

  /** A single CSS class name to be appended to the root element. */
  className: PropTypes.string,

  /** Callback function called with a Date or a Range whenever the user selects a day in the calendar */
  onChange: PropTypes.func.isRequired,

  /** Callback function called whenever user press escape or click outside of the element or a date is selected and `shouldCloseOnSelect` is set. Receives an event as first argument */
  onClose: PropTypes.func,

  /** Past dates are unselectable */
  excludePastDates: PropTypes.bool,

  /**
   * ##### Determines selectable dates
   *  * `param` {Date} `date` - a date to check
   *  * `return` {boolean} - true if `date` should be selectable, false otherwise
   */
  filterDate: PropTypes.func,

  /** The selected date */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date), PropTypes.shape({
    from: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
  })]),

  /** Whether the user should be able to select a date range, or just a single day */
  selectionMode: PropTypes.oneOf(['day', 'range']),

  /** Display a selectable yearDropdown */
  showYearDropdown: PropTypes.bool,

  /** Display a selectable monthDropdown */
  showMonthDropdown: PropTypes.bool,

  /** should the calendar close on day selection */
  shouldCloseOnSelect: PropTypes.bool,

  /** DatePicker instance locale */
  locale: PropTypes.oneOfType([PropTypes.oneOf(['en', 'es', 'pt', 'fr', 'de', 'pl', 'it', 'ru', 'ja', 'ko', 'tr', 'sv', 'no', 'nl', 'da', 'zh', 'th', 'cs']), PropTypes.shape({
    distanceInWords: PropTypes.object,
    format: PropTypes.object
  })])
};

function nextDay(date) {
  var day = new Date(date);
  day.setDate(day.getDate() + 1);
  return day;
}

function prevDay(date) {
  var day = new Date(date);
  day.setDate(day.getDate() - 1);
  return day;
}